import React from 'react';
import { createMergingContextProvider } from '@wix/da-react-context/pkg/helpers';
const BiContext = /*#__PURE__*/ React.createContext({});
BiContext.displayName = 'BiContext';
const BiLoggerContextConsumer = BiContext.Consumer;
/**
 * Merge context for nested providers
 */ const BiLoggerContextProvider = createMergingContextProvider(BiContext, 'BiLoggerContextProvider');
export { BiLoggerContextProvider, BiLoggerContextConsumer, BiContext };

//# sourceMappingURL=BiLogger.context.js.map